/* Proaid Nutrition — bundle builder.
   Client-side selection against real variant IDs/prices, added to the
   cart in one /cart/add.js call. Tier savings (5% at 2, 10% at 3,
   15% at 4+) are display estimates — the real discount comes from the
   store's automatic discount at checkout. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bundle]');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-item][data-variant-id]'));
  var selection = {}; /* variantId -> { qty, price } */

  var subtotalEl = root.querySelector('[data-bundle-subtotal]');
  var savingRow = root.querySelector('[data-bundle-saving-row]');
  var savingLabel = root.querySelector('[data-bundle-saving-label]');
  var savingEl = root.querySelector('[data-bundle-saving]');
  var totalEl = root.querySelector('[data-bundle-total]');
  var countLabel = root.querySelector('[data-bundle-count-label]');
  var nextTierEl = root.querySelector('[data-bundle-next-tier]');
  var barEl = root.querySelector('[data-bundle-bar]');
  var submitBtn = root.querySelector('[data-bundle-submit]');

  function money(cents) { return window.theme.formatMoney(cents); }

  function tierFor(count) {
    if (count >= 4) return 0.15;
    if (count === 3) return 0.10;
    if (count === 2) return 0.05;
    return 0;
  }

  function nextTierFor(count) {
    if (count < 2) return { qty: 2, save: '5%' };
    if (count < 3) return { qty: 3, save: '10%' };
    if (count < 4) return { qty: 4, save: '15%' };
    return null;
  }

  function render() {
    var count = 0;
    var subtotal = 0;
    Object.keys(selection).forEach(function (id) {
      count += selection[id].qty;
      subtotal += selection[id].qty * selection[id].price;
    });

    var tier = tierFor(count);
    var discount = Math.round(subtotal * tier);
    var total = subtotal - discount;

    if (subtotalEl) subtotalEl.textContent = money(subtotal);
    if (savingRow) savingRow.hidden = discount === 0;
    if (savingLabel) savingLabel.textContent = 'Bundle saving (' + Math.round(tier * 100) + '%)';
    if (savingEl) savingEl.textContent = '-' + money(discount);
    if (totalEl) totalEl.textContent = money(total);
    if (countLabel) countLabel.textContent = count + (count === 1 ? ' item selected' : ' items selected');

    var next = nextTierFor(count);
    if (nextTierEl) nextTierEl.textContent = next ? 'Add ' + (next.qty - count) + ' for ' + next.save + ' off' : '';
    if (barEl) barEl.style.width = Math.min(100, (count / 4) * 100) + '%';
    if (submitBtn) submitBtn.disabled = count === 0;

    items.forEach(function (item) {
      var id = item.getAttribute('data-variant-id');
      var qty = selection[id] ? selection[id].qty : 0;
      item.classList.toggle('is-selected', qty > 0);
      var addBtn = item.querySelector('[data-bundle-add]');
      var stepper = item.querySelector('[data-bundle-stepper]');
      var qtyEl = item.querySelector('[data-bundle-qty]');
      if (addBtn) addBtn.hidden = qty > 0;
      if (stepper) stepper.hidden = qty === 0;
      if (qtyEl) qtyEl.textContent = qty;
    });
  }

  function change(item, delta) {
    var id = item.getAttribute('data-variant-id');
    var price = Number(item.getAttribute('data-price'));
    var current = selection[id] ? selection[id].qty : 0;
    var next = current + delta;
    if (next <= 0) delete selection[id];
    else selection[id] = { qty: next, price: price };
    render();
  }

  items.forEach(function (item) {
    var addBtn = item.querySelector('[data-bundle-add]');
    var plus = item.querySelector('[data-bundle-plus]');
    var minus = item.querySelector('[data-bundle-minus]');
    if (addBtn) addBtn.addEventListener('click', function () { change(item, 1); });
    if (plus) plus.addEventListener('click', function () { change(item, 1); });
    if (minus) minus.addEventListener('click', function () { change(item, -1); });
  });

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var lines = Object.keys(selection).map(function (id) {
        return { id: Number(id), quantity: selection[id].qty };
      });
      if (lines.length === 0) return;
      var originalLabel = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
      window.theme.addToCart(lines)
        .then(function () {
          selection = {};
          render();
        })
        .catch(function (error) {
          var el = root.querySelector('[data-cart-error]');
          if (el) {
            el.textContent = error.message || window.theme.strings.cartError;
            el.hidden = false;
            window.setTimeout(function () { el.hidden = true; }, 4000);
          }
        })
        .finally(function () {
          submitBtn.textContent = originalLabel;
          render();
        });
    });
  }

  render();
})();
